import { ITableRowProps } from "../../../interfaces/table-row-props";
import styles from "./table-row.module.scss";

const TableRow = (props: ITableRowProps) => {
  const { data, disable } = props;
  return (
    <tr
      style={{ verticalAlign: "middle" }}
      className={`${disable && styles.disable}`}
    >
      <>
        {data.map((item, index) => (
          <td key={index} className="text-color-2 font-size-12 font-weight-400">
            {item}
          </td>
        ))}
      </>
    </tr>
  );
};

export default TableRow;
